<template>
  <ul>
    <li
      v-for="route in routes"
      :key="route.slug"
      class="nav-list"
    >
      <NuxtLink
        class="nav-list__link"
        :active-class="'active'"
        :to="route.slug"
        data-testid="nav-list__link"
        @click="
          trackEvent(eventNames.CARRIER_PROFILE_INTERNAL_LINK_CLICKED, {
            from: nuxtRoute.fullPath,
            to: route.slug,
          })
        "
      >
        {{ route.name }}
      </NuxtLink>
    </li>
  </ul>
</template>
<script setup>
const props = defineProps({
  routes: Array,
  default: [],
});
const nuxtRoute = useRoute();
const { trackEvent, eventNames } = useAcvAnalytics();
</script>
<style lang="scss" scoped>
.nav-list {
  @apply tw-mb-3;

  &__link {
    @apply tw-block tw-w-full tw-rounded-full tw-border-2 tw-border-solid tw-border-transparent tw-bg-white tw-p-4 tw-text-base tw-font-regular tw-text-text-secondary tw-no-underline;

    &:hover {
      @apply tw-bg-grey-light;
    }

    &:focus-visible {
      border-color: #7b61ff;
    }

    &:active {
      @apply tw-bg-grey-base;
    }

    &.active {
      @apply tw-bg-secondary-light-x tw-font-medium tw-text-secondary-base;

      background-image: none;
    }
  }
}
</style>
